module.exports = __webpack_public_path__ + "img/GS_Profile-Dorah Mmantite Matjila.65f66c5d.png";